import { useMemo } from "react";

import { useStore } from "../../stores/StoreContext";
import { WhitelabelService } from "../LogicServices/WhitelabelService";

export function useWhitelabelService(): WhitelabelService {
  const storeContext = useStore();
  return useMemo(() => new WhitelabelService(storeContext), [storeContext]);
}
